;(function(w){
	function LightboxContenido(){
		var self = this;
		this.main = document.getElementById('lightbox_contenido');

		var titulo = $(this.main).find('.titulo')[0];

		var holder_hotspots = $(this.main).find('.holder_hotspots')[0];
		var volver_btn = $(this.main).find('.return')[0];

		var actual;
		var contenidos;

		var content_holder = $(this.main).find('.content_holder');

		var content_section;
		
		var arr_hotspots;

		var abierto = false;

		var data;

		$(volver_btn).bind('click', onClickVolverBtn);
		$(this.main).bind('LIGHTBOX_CONTENIDO_HOTSPOT_CLICK', onClickHotspot);


		this.mostrar = function($actual, $data){
			actual = $actual;
			data = $data;
			contenidos = data.contenidos;

			$(titulo).html(data.titulo.blanco+'<br/>'+data.titulo.amarillo);
			

			abierto = true;

			$(holder_hotspots).empty();

			arr_hotspots = [];

			contenidos.forEach(function(contenido, index){
				arr_hotspots.push(new LightboxContenidoHotspot(index, contenido.hotspot));
				$(holder_hotspots).append(arr_hotspots[arr_hotspots.length - 1].main);
			});

			$(self.main).addClass('active');

			setContenido(actual);
		}

		this.ocultar = function(){
			$(self.main).removeClass('active');
			$(content_holder).empty();

			abierto = false;
		}		

		this.estaAbierto = function(){
			return abierto;
		}

		function onClickVolverBtn(e){
			e.preventDefault();
			self.ocultar();
		}

		function setContenido(id){
			ga('send', {hitType: 'event', eventCategory: 'Contenido Capitulo - '+data.titulo.blanco+' '+data.titulo.amarillo,  eventAction: 'Show Content', eventLabel: data.contenidos[id].hotspot.texto});

			arr_hotspots[actual].setActive(false);
			actual = id;
			arr_hotspots[actual].setActive(true);

			$(content_holder).empty();

			content_section = new LightboxContenidoHTMLContent(contenidos[actual].file);
			
			$(content_holder).append(content_section.main);
		}

		function onClickHotspot(e){
			setContenido(e.index);
		}

	}
	
	w.LightboxContenido = LightboxContenido;
})(window)